import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VideoControlsComponent } from '../video-controls/video-controls.component';

@Component({
  selector: 'studio-download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.scss'],
})
export class DownloadButtonComponent {
  protected get videoUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.videoControls.video.src);
  }

  constructor(protected videoControls: VideoControlsComponent, private sanitizer: DomSanitizer) {}
}
